import IndividualPrintEdit from './IndividualPrintEdit';

export default IndividualPrintEdit;
